module.exports = __webpack_public_path__ + "img/monitor.3dc85e16.svg";